import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en-US.json'
import ru from './locales/ru-RU.json'

const resources = {
  en: { translation: en },
  ru: { translation: ru },
}

const detectDefaultLanguage = (): string => {
  if (typeof navigator !== 'undefined') {
    const normalized = navigator.language.trim().toLowerCase()
    if (normalized.startsWith('ru')) return 'ru'
    if (normalized.startsWith('en')) return 'en'
  }
  return 'en'
}

void i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: detectDefaultLanguage(),
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((error) => {
    if (import.meta.env.DEV) {
      console.error('Failed to initialize i18n', error)
    }
  })

export default i18n
